import { authentication } from './authentication.reducer';

export default {
    authentication
}